import { getGlobalProperty } from "@faire/globals/deprecated/getGlobalProperty";
import { singletonGetter } from "@faire/globals/deprecated/singletonGetter";
import { IntlCache, IntlShape } from "@formatjs/intl/lib/src/types";
import { createIntlCache } from "@formatjs/intl/lib/src/utils";

type CachedIntl = {
  intl: IntlShape<string>;
};

/**
 * @deprecated use `useLocalizationCacheStore`
 */
export class LocalizationCacheStore {
  static get = singletonGetter(LocalizationCacheStore, {
    globalSingleton: getGlobalProperty("isMainThread"),
  });

  _cachedIntl: {
    [key: string]: CachedIntl;
  } = {};

  readonly cache: IntlCache = createIntlCache();

  setCachedIntl = (locale: string, intl: IntlShape<string>) => {
    this._cachedIntl[locale] = {
      intl,
    };
  };

  getCachedIntl = (locale: string) => {
    return this._cachedIntl[locale];
  };
}
